import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import { useMediaQuery, Divider } from '@mui/material';
import { Topbar, Footer, Sidebar } from './components';

const Root = styled('div')(({ theme }) => ({
  height: '100%',
}));

const Main = ({ children, themeToggler, themeMode }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const pages = {
    landings: {
      title: 'Solutions',
      id: 'solutions',
      children: {
        solutions: {
          groupTitle: 'Solutions',
          pages: [
            {
              title: 'Mperito Shop',
              href: '/solutions/shop',
            },
            {
              title: 'Mperito POS',
              href: '/solutions/pos',
            },   
            {
              title: 'Mperito Services',
              href: '/solutions/service',
            },   
            {
              title: 'ONDC Solutions',
              href: '/ondc',
            },        
          ],
        },
      },
    },
    about: {
      title: 'About',
      id: 'about',
      children: {
        company: {
          groupTitle: 'Company',
          pages: [
            {
              title: 'About',
              href: '/about/#about',
            },
            {
              title: 'Our Story',
              href: '/about/#about-story',
            },
            // {
            //   title: 'Our Team',
            //   href: '/about/#about-team',
            // },
            // {
            //   title: 'Core Values',
            //   href: '/#home-core_values',
            // },
            {
              title: 'Contact Details',
              href: '/about/#about-contact',
            },
          ],
        },
      },
    },
    legal: {
      title: 'Policies',
      id: 'policies',
      children: {
        policies: {
          groupTitle: 'Policies',
          pages: [
            {
              title: 'Privacy Policy',
              href: '/policy/privacy',
            },
            {
              title: 'Terms & Conditions',
              href: '/policy/terms',
            },
            {
              title: 'Shipping Policy',
              href: '/policy/shipping',
            },
            {
              title: 'Return Policy',
              href: '/policy/returns',
            },
            {
              title: 'Refund Policy',
              href: '/policy/refund',
            },
            {
              title: 'ONDC Seller App Policy',
              href: '/policy/ondc_seller_app',
            },

          ]
        }
      }
    },
    ondc: {
      title: 'ONDC',
      id: 'ondc',
      children: {
        ondc: {
          groupTitle: 'ONDC Solutions',
          pages: [
            {
              title: 'ONDC',
              href: '/ondc',
            },
          ]
        }
      }
    }
  };

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const open = isMd ? false : openSidebar;

  return (
    <Root>
      <Topbar 
        onSidebarOpen={handleSidebarOpen} 
        pages={pages} 
        themeMode={themeMode} 
        themeToggler={themeToggler} 
      />
      <Sidebar
        onClose={handleSidebarClose}
        open={open}
        variant="temporary"
        pages={pages}
      />
      <main>
        <Divider />
        {children}
      </main>
      <Footer pages={pages} />
    </Root>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  themeToggler: PropTypes.func.isRequired,
  themeMode: PropTypes.string.isRequired,
};

export default Main;
